var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.92 27.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.47,25a8.53,8.53,0,0,0-11.63.85l-1.23,1.27-1.23-1.27A8.52,8.52,0,0,0,25.75,25a9,9,0,0,0-.92,12.63c.09.11.2.23.3.33L37.19,50.38a2,2,0,0,0,2.77.06l.06-.06L52.08,37.92a8.93,8.93,0,0,0-.27-12.64C51.7,25.17,51.59,25.06,51.47,25Z",
    transform: "translate(-22.65 -23.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7cad5218f1763b4de78cb40b6a2b6936.svg";
export { ForwardRef as ReactComponent };